import supabase from '../supabase/supabase';

class FavoritesService {
  async getFavorites() {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return [];

    const { data, error } = await supabase
      .from('favorite_meals')
      .select('*')
      .eq('user_id', user.id)
      .order('favorited_at', { ascending: false });

    if (error) {
      console.error('Error fetching favorites:', error);
      return [];
    }
    return data;
  }

  async addFavorite(meal, tags) {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return null;

    const newFavorite = {
      user_id: user.id,
      tags: tags,
      meal_plan: meal,
    };

    const { data, error } = await supabase
      .from('favorite_meals')
      .insert(newFavorite)
      .select()
      .single();

    if (error) {
      console.error('Error adding favorite:', error);
      return null;
    }
    return data;
  }

  async removeFavorite(favoriteId) {
    const { error } = await supabase
      .from('favorite_meals')
      .delete()
      .eq('id', favoriteId);

    if (error) {
      console.error('Error removing favorite:', error);
    }
  }
}

export default new FavoritesService();